import { CmsDocument, CmsMenu, CmsMenuItem, resolveLocale, safeCmsUrl } from './cms-document';
import { simpleVisible } from './simple-language';

// The footer and its panel must agree about which published links are usable.
export function availableMobileMenus(document:CmsDocument|undefined|null,language:string):CmsMenu[] {
 if(!document?.enabled)return [];
 const items=(source:CmsMenuItem[]):CmsMenuItem[]=>(source||[]).reduce((result:CmsMenuItem[],item)=>{
  const children=items(item.children);
  const page=document.pages.find(p=>p.id===item.pageId&&!p.archived&&simpleVisible(p.legacyVisibility,language)&&!!resolveLocale(p,language,document.defaultLanguage));
  const pageId=page?.id;
  const url=!item.pageId&&item.url?.trim()&&safeCmsUrl(item.url)?item.url:'';
  const label=item.labels?.[language]||item.labels?.[document.defaultLanguage]||item.labels?.en;
  if(label?.trim()&&(item.languagePicker||pageId||url||children.length))result.push({...item,pageId,url,children});
  return result;
 },[]);
 return (document.menus||[]).filter(menu=>menu.placement==='mobile').map(menu=>({...menu,items:items(menu.items)})).filter(menu=>menu.items.length>0);
}
